import { ButtonDoneLogic as ButtonDone } from './ButtonDone.logic'

export default ButtonDone
